import { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, readOnly = false, size = 18 }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;

  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((s) => (
        <button
          type="button"
          key={s}
          disabled={readOnly}
          onClick={() => !readOnly && onChange?.(s)}
          onMouseEnter={() => !readOnly && setHover(s)}
          onMouseLeave={() => !readOnly && setHover(0)}
          className={`transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"}`}
          data-testid={readOnly ? undefined : `star-${s}`}
          aria-label={`${s} star${s > 1 ? "s" : ""}`}
        >
          <Star
            style={{ width: size, height: size }}
            className={active >= s ? "fill-primary text-primary" : "text-muted-foreground/40"}
          />
        </button>
      ))}
    </div>
  );
}
